<template>
    <div>
        <div>
            <div class="xinz">
                <template v-if="canAdd">
                    <div class="right">
                        <el-button type="primary"  @click="addStaff('','添加')"><i class="fa fa-plus" /> 新增</el-button>
                    </div>
                </template>
            </div>
            <div>
                <el-form :inline="true"  class="demo-form-inline" size="small" @submit.native.prevent @keyup.native.enter="requestStaffList">
                    <el-form-item :label="$t('m.t_search')+'：'">
                        <el-input :placeholder="$t('m.s_login')" clearable v-model="searchName">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="searchRids"  filterable clearable placeholder="角色" >
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                <span style="float: left">{{ item.label }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="searchCanLogin" placeholder="狀態" clearable>
                            <el-option v-for="item in openStopOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="requestStaffList"><i class="fa fa-search" />{{$t('m.b_query')}}</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="ind_main ind_main2">
                <div class="ind_cont2 ">
					 <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
					             
					              :data="staffs"
					              empty-text="无数据"
					              stripe
					              border
					              class="dataListTable">
								  <el-table-column prop="loginName" label="用戶名" > </el-table-column>
					        <el-table-column
					                prop="name"
					                align="left"
					                label="別名">
					        </el-table-column>
					        <el-table-column
					                prop="rName"
					                align="left"
					                label="角色">
					        </el-table-column>
					        <el-table-column
					                prop="email"
					                align="left"
					                label="郵箱">
					        </el-table-column>
							<el-table-column
							        prop="canLogin"
							        align="left"
							        label="狀態">
									 <template slot-scope="scope">
									                                <template v-if="scope.row.canLogin == 1">
									                                    啟用
									                                </template>
									                                <template v-else="">
									                                    停用
									                                </template>
									                            </template>
							</el-table-column>
							
					        <el-table-column
					                prop="id"
					                width="100"
					                align="center"
					                label="操作">
					          <template slot-scope="scope">
					            <template>
					              <el-dropdown>
					                <el-button size="small" type="primary">
					                  <i class="fa fa-mouse-pointer"/>操作
					                </el-button>
					                <el-dropdown-menu slot="dropdown">
					                                                     <el-dropdown-item  @click.native="addStaff(scope.row,'修改')" v-if="canEdit"><i class="fa fa-edit"/> 編輯</el-dropdown-item>
					                                                     <el-dropdown-item  @click.native="addStaffPwd(scope.row,'修改密碼')" v-if="editPwd"><i class="fa fa-edit"/> 修改密碼</el-dropdown-item>
					                                                     <el-dropdown-item  @click.native="delStaff(scope.row.id,scope.row.loginName)" v-if="canDel"><i class="fa fa-trash"/> 刪除</el-dropdown-item>
					                                                 </el-dropdown-menu>
					              </el-dropdown>
					            </template>
					          </template>
					        </el-table-column>
					      </el-table>
					
					
					
					
					
           
                    <div class="pagination">
                    <el-pagination
                            layout="total, prev, pager, next"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pager.page"
                            :page-size="pager.size"
                            :total="pager.total">
                    </el-pagination>
                </div>
                </div>
                <el-dialog
                        :title="title"
                        :visible.sync="dialogVisible"
                        width="400px">
                    <el-form ref="staffForm" :model="staffForm" label-width="85px" style="text-align: center" >
                        <el-form-item label="帳  號:" >
                            <el-input v-model="staffForm.loginName" size="small"  @change="selLoginName(staffForm.loginName,validatNum)" placeholder="請輸入帳號"></el-input>
                        </el-form-item>
                        <template v-if="addList">
                            <el-form-item label="密  碼:">
                                <el-input v-model="staffForm.password" type="password" size="medium"  placeholder="請輸入密碼"></el-input>
                            </el-form-item>
                            <el-form-item label="確認密碼:" >
                                <el-input v-model="staffForm.password1" type="password" size="medium" placeholder="請確認密碼"></el-input>
                            </el-form-item>
                        </template>
                        <el-form-item label="狀  態:">
                            <el-select v-model="staffForm.canLogin" placeholder="請選擇狀態" size="medium" style="width: 100%">
                              <!--  <el-option v-for="item in openStopOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>-->
                                <el-option
                                        v-for="item in openStopOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="姓  名:" >
                            <el-input v-model="staffForm.name" size="medium"  placeholder="請輸入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="角  色:" >
                            <el-select v-model="staffForm.rName" placeholder="請選擇角色" size="medium" @change="roleIdName()" style="width: 100%">
                                <el-option
                                        v-for="item in roleList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <!--<el-input v-model="form.rName"  placeholder="請輸入角色"></el-input>-->
                        </el-form-item>
                        <el-form-item label="郵  箱:" >
                            <el-input v-model="staffForm.email" size="medium" placeholder="請輸入郵箱"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary"  icon="el-icon-check" @click="submitStaff()" >確 定</el-button>
                            <el-button @click="cancelAddStaff()" icon="el-icon-error" >取 消</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
                <!-- 修改密碼彈出框-->
                <el-dialog title="修改密碼"  :visible.sync="dialogFormVisible" width="400px">
                    <el-form :model="staffForm"  size="small"  ref="staffForm" label-width="120px">
                        <el-form-item label="輸入新密碼" prop="password">
                            <el-input type="password"  v-model="staffForm.password"  auto-complete="off" widht="160px" placeholder="請輸入新密碼"></el-input>
                        </el-form-item>
                        <el-form-item label="確認新密碼" label-width="120px" prop="confirmPassword">
                            <el-input type="password" v-model="staffForm.password1"  auto-complete="off" widht="160px" placeholder="請確認新密碼"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary"  icon="el-icon-check" @click="modifyStaffPassword(staffForm)" >確 定</el-button>
                            <el-button @click="dialogFormVisible = false" icon="el-icon-error" >取 消</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </div>
        </div>
    </div>

</template>

<script>
    import {getStaffList,getAllRoleList,insertStaff,deleteStaff,updateStaff,getStaffByLoginName,modifyStaffByIdPassword } from '../api/api'
    export default {
        data() {
            var validateName=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("帳號不能為空"));
                }else {
                    callback();
                }
            };
            return {
                staffs:[],
                roleList:[],
                addList:true,
                dialogVisible: false,
                dialogFormVisible:false,
                title:"",//名称
                staffTableloading:false,
                updateStaff:"",//修改时验证是否是当前修改的用户
                searchName:'',
                searchRids:'',
                searchCanLogin:'',
                pager:{
                    page:0,
                    size:15,
                    total:0
                },
                openStopOptions: [ {
                    value: 1,
                    label: this.$t('m.t_enable')
                },{
                    value: 2,
                    label: this.$t('m.t_stop')
                }],
                staffForm:{
                    loginName:'',
                    password:'',
                    password1:'',
                    name:'',
                    rName:'',
                    email:'',
                    canLogin:1,
                    id:0,
                    roleId:0,
                },
                validatNum:0,
            }
        },
        methods: {
            selLoginName(loginName,num){
                /*查詢当前的帐号是否重复*/
                if((loginName.toUpperCase()==this.staffLL.toUpperCase()) &&num==0){
                    this.staffForm.loginName = "";
                    this.validatNum=1;
                }else {
                    getStaffByLoginName(loginName).then(data => {
                        let {data: res = {}} = data;
                        if (res.errcode === 200) {
                            if (res.data != null) {
                                if (res.data.loginName !== this.updateStaff) {//当前輸入的帐号是否是修改的帐号
                                    this.$alert("当前员工:" + this.staffForm.loginName + " 已存在!", '提示', {
                                        confirmButtonText: '確定',
                                        type: 'warning',
                                        callback: action => {
                                            this.staffForm.loginName = "";
                                        }
                                    });
                                }
                            }
                        } else {
                            this.$message.error(res.errmsg);
                        }
                    })
                }
            },
            requestStaffList(){/*查詢所有的员工*/
                this.staffTableloading=true;
                let params={page:this.pager.page,size:this.pager.size,name:this.searchName.trim(),staffId:this.searchRids,loginId:this.searchCanLogin};
                return getStaffList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        let {size,page,total,data:staffs=[]}=res.data;
                        this.staffs=staffs;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.staffTableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            selRole(){/*查詢角色*/
                return getAllRoleList().then(data  =>{
                    let {data:res={}}=data;
                    if(res.errcode === 200){
                        let roleMap= new Map();
                        res.data.forEach((item,i)=>{
                            roleMap.set(i,{value:item.id,label:item.name});
                        });
                        this.roleList =[... roleMap.values()];

                    }
                })
            },
            delStaff(id,name){/*删除会员*/
                this.$confirm('確定要刪除員工'+name+'?', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    return deleteStaff(id).then( data=>{
                        let {data:res={}}=data;
                        if(res.errcode===200){
                            this.$message({
                                type: 'success',
                                message: '刪除成功!'
                            });
                            this.isEmptyNull();
                            this.requestStaffList();
                        }
                    });
                })
            },
            roleIdName(){/*選擇角色*/
                this.staffForm.roleId=this.staffForm.rName;
            },

            addStaff(item,str){/*点击添加*/
                this.validatNum=0;
                this.updateStaff="";
                this.isEmptyNull();
                this.dialogVisible = true;
                if(str === "添加"){
                    this.title = "添加員工";
                    this.addList = true;
                }else{
                    this.updateStaff =item.loginName;
                    this.addList = false;
                    this.title = "修改員工";
                    this.staffForm.loginName=item.loginName;
                    this.staffForm.name=item.name;
                    this.staffForm.rName=item.rName;
                    this.staffForm.roleId=item.roles[0].id;
                    this.staffForm.email=item.email;
                    this.staffForm.id=item.id;
                    this.staffForm.canLogin=item.canLogin;
                    if(item.canLogin==1){
                        this.openStopOptions[0].value =item.canLogin;
                    }else{
                        this.openStopOptions[1].value =item.canLogin;
                    }
                }
            },
            addStaffPwd(item,str){/*修改员工密码*/
                this.staffForm.id=item.id;
                this.dialogFormVisible=true;
            },
            modifyStaffPassword(formName){//修改密碼
                let str = "";
                if(this.staffForm.password ==="" || this.staffForm.password === null){
                    str = "登錄密碼不能為空"
                }if(this.staffForm.password1 ==="" || this.staffForm.password1 === null){
                    str = "確認密碼不能為空"
                }if(this.staffForm.password1 !== this.staffForm.password){
                    str = "兩次密碼不一樣"
                }
                if(str !== ""){
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error',
                    });
                    this.staffForm.password = "";
                    this.staffForm.password1 = "";
                }else {
                    this.$refs.form.validate((valid) => {
                        if (valid) {
                            return modifyStaffByIdPassword({password:this.staffForm.password,id:this.staffForm.id}).then(data => {
                                let {data: res = {}} = data;
                                if (res.errcode === 200) {
                                    this.$message({
                                        message: "修改成功",
                                        type: 'success'
                                    });
                                    this.dialogFormVisible = false;
                                    this.staffForm.password = '';
                                    this.staffForm.password1 = '';
                                    this.isEmptyNull();
                                } else {
                                    this.$message({
                                        message: "修改失敗",
                                        type: 'warning'
                                    });
                                }
                            });
                        }
                    });
                }
            },
            handleCurrentChange(){/*分頁*/
                this.requestStaffList();
            },
            submitStaff(){/*添加员工*/
                if(this.staffForm.loginName =="" || this.staffForm.loginName == null){
                    return "帳號不能為空"
                }
                this.dialogVisible = false;
                let str = this.isNull();
                if(str !== ""){
                    this.dialogVisible =true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                }else {
                    var params={
                        loginName:this.staffForm.loginName,
                        password:this.staffForm.password1,
                        name:this.staffForm.name,
                        email:this.staffForm.email,
                        roleId:this.staffForm.roleId,
                        canLogin:this.staffForm.canLogin,
                        id:this.staffForm.id
                    };

					if(this.addList === true){//添加员工
						return insertStaff(params).then(data =>{
							let {data:res={}}=data;
							//console.log("res",res);
							if(res.errcode===200){
								this.$alert('添加員工成功!', '添加員工', {
									confirmButtonText: '確定',
									callback: action => {
										this.isEmptyNull();
										this.requestStaffList();
									}
								});
							}else {
                                this.$message.error("添加員工失败！");
                            }
						});
					}else{//修改员工
						return updateStaff(params).then(data =>{
							let {data:res={}}=data;
							//console.log("res",res);
							if(res.errcode===200){
								this.$alert('修改員工成功!', '員工', {
									confirmButtonText: '確定',
									callback: action => {
										this.isEmptyNull();
										this.requestStaffList();
									}
								});
							}else {
                                this.$message.error("修改員工失败！");
                            }
						})
					}
                }
            },
            cancelAddStaff(){
                this.dialogVisible = false;
                this.isEmptyNull();
            },
            isEmptyNull(){/*清空*/
                this.staffForm.loginName='';
                this.staffForm.password='';
                this.staffForm.password1='';
                this.staffForm.name='';
                this.staffForm.rName='';
                this.staffForm.email='';
                this.updateStaff="";
                this.validatNum=0;
            },

            isNull(){/*是否为空*/
                if(this.staffForm.loginName ==="" || this.staffForm.loginName === null){
                    return "帳號不能為空"
                }
				if(this.addList===true){
					if(this.staffForm.password ==="" || this.staffForm.password === null){
						return "登錄密碼不能為空"
					}if(this.staffForm.password1 ==="" || this.staffForm.password1 === null){
						return "確認密碼不能為空"
					}
				}
				if(this.staffForm.password1 !== this.staffForm.password){
                    return "兩次密碼不一樣"
                }if(this.staffForm.name ==="" || this.staffForm.name === null){
                    return "姓名不能為空"
                }if(this.staffForm.rName ==="" || this.staffForm.rName === null){
                    return "角色不能為空"
                }
                if(this.staffForm.email!=null && this.staffForm.email !=""){
                    var reg = /^((([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6}\;))*(([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})))$/;
                    if(!reg.test(this.staffForm.email)){
                        return "請輸入正确的邮箱地址"
                    }
                }
                return "";
            },
        },
        mounted() {

        },
        computed: {
            staffLL(){
                return this.$store.getters.staff.loginName;
            },
            canAdd(){
                return this.$store.getters.hasPermission("STAFF_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("STAFF_EDIT");
            },
            canDel(){
                return this.$store.getters.hasPermission("STAFF_DEL");
            },
            editPwd(){
                return this.$store.getters.hasPermission("EDIT_FTAFF_PWD");
            },
        },
        activated(){
            //初始化員工類型
            this.selRole();
            this.requestStaffList();
        }
    }

</script>

<style lang="scss" scoped>
    .el-form-item {
        margin-bottom: 5px;
    }
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 1px;
        margin-top: 1px;
    }
    .xinz button{background:#4B78FF;border:none;margin-bottom:1rem;}
    .xinz button:hover{background:#215ec3;color:#fff;}
     .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{background-color:#aab5c5 }

</style>




// WEBPACK FOOTER //
// src/views/Staff.vue